/* @flow */
import cx from 'classnames';
import * as React from 'react';

import Button from 'components/Button';
import { clearDraftAnnouncement } from 'groups/actions/DraftMessageActions';
import ConfirmDialog from 'components/ConfirmDialog';
import Message from 'entities/Message';
import MessageActions from 'groups/actions/MessageActions';
import ModalTrigger from 'components/ModalTrigger';
import MessageItemContent from 'chat/components/MessageItemContent';
import { SplitComposerModal } from 'chat/components/SplitComposer';

import GroupMessageBase from './GroupMessageBase';
import GroupMessageHeader from './GroupMessageHeader';
import GroupMessageHeaderAction from './GroupMessageHeaderAction';
import GroupMessageInformation from './GroupMessageInformation';

import './styles/GroupScheduledMessage.scss';

class GroupScheduledMessage extends React.Component<{
  message: Message,
  className: string,
  target?: *,
}> {
  // TODO: Figure out a better way to ignore this click
  // while allowing the event to bubble
  clickHandler(event: SyntheticEvent<>) {
    // Prevents the GroupScheduledMessageList from toggling
    // when clicking inside its child (i.e., this)
    event.stopPropagation();
  }

  remove = () => {
    MessageActions.destroyScheduledMessage(this.props.message);
  };

  renderMessage() {
    const { message } = this.props;
    const sender = message && message.getSender();
    const isUrgent = message && message.get('urgent');
    const senderId = sender && sender.id;
    const modal = (
      <SplitComposerModal
        draftAnnouncement={message}
        initialTargets={[this.props.target]}
        onDismiss={() => clearDraftAnnouncement()}
        isEditingScheduledMessage
        skipSelectRecipients
        messageType={isUrgent ? 'urgent' : 'message'}
      />
    );
    return (
      <GroupMessageBase message={message}>
        <GroupMessageHeader
          author={sender && sender.getName()}
          initials={sender && sender.getInitials()}
          senderId={senderId}>
          <div>
            <ModalTrigger modal={modal}>
              <Button level="secondary" size="small">
                Edit
              </Button>
            </ModalTrigger>
            {this.renderRemoveAction()}
          </div>
        </GroupMessageHeader>
        <MessageItemContent message={message} />
        <GroupMessageInformation message={message} />
      </GroupMessageBase>
    );
  }

  renderRemoveAction() {
    const modal = (
      <ConfirmDialog
        eventScreenName="GroupScheduledMessage"
        title="Are you sure you want to delete this announcement?"
        actionButtonText="Delete"
        cancelButtonText="Cancel"
        onConfirm={this.remove}
      />
    );

    return (
      <ModalTrigger modal={modal} data-test-selector="delete-modal-trigger">
        <GroupMessageHeaderAction color="lava">Delete</GroupMessageHeaderAction>
      </ModalTrigger>
    );
  }

  render() {
    const { className } = this.props;
    return (
      <div className={cx('GroupScheduledMessage', className)} onClick={this.clickHandler}>
        {this.renderMessage()}
      </div>
    );
  }
}

export default GroupScheduledMessage;
